import { GanttInstance } from './types';

export const HOUR_TO_DAY_FIELDS = ['duration', 'totalSlack', 'freeSlack'];

// Default sort criteria when sort it's deactivated
export const DEFAULT_SORT_CRITERIA = {
  criteria: [
    {
      name: 'correlative_id',
      label: 'Correlative ID',
      data_type: 'number' as const,
      order_by: 'asc' as const
    }
  ]
};

// Convert dates to YYYY/MM/DD format
export const formatDate = (date: number | string | Date): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
};

export const getTaskDate = (date: number | string | Date): string =>
  typeof date === 'string' ? date.split(' ')[0] : formatDate(date);

export const isNullOrUndefined = (value: unknown): boolean =>
  typeof value === 'undefined' || value === null;

export const getScrollState = (gantt: GanttInstance) =>
  gantt?.getScrollState?.();

export const restoreScrollState = (gantt: GanttInstance, scrollState: any) => {
  if (!scrollState || !gantt.scrollTo) return;

  gantt.scrollTo(scrollState.x, scrollState.y);
  if (gantt.$layout && gantt.$layout.resize) {
    gantt.$layout.resize();
  }
};
